import React from 'react'
import ScrollableBody from './ScrollableBody'
import ColumnFlexBox from './ColumnFlexBox'
import RowFlexBox from './RowFlexBox'
import FlexBox from './FlexBox'
import CapacityAndPlatform from './CapacityAndPlatform'
import SegmentsComposition from './SegmentsComposition'
import DemographicsBox from './DemographicsBox'
import BrandIndex from './BrandIndex'
import Chart from './Chart'
import Gender from './Gender'
import { InfraComponents } from '../../../InfraFacade'

import './SegmentsPopupContent.less'

const { ScopeSelection, Icon, Tabs, Tab } = InfraComponents

const Popup = (props) => {
  return (
        <div className='segments-popup-body'>
            <Tabs activeKey={1}>
                <Tab eventKey={1} title='Summary'>
                    <ScrollableBody>
                        <SegmentsComposition />
                        <RowFlexBox className='capacity-platform-scope' width='initial'>
                            <CapacityAndPlatform
                              count={props.count}
                              platform={props.platformData}
                            />
                            <div className='vertical-separator' />
                            <ColumnFlexBox className='flex-1-auto center' width='initial'>
                                <RowFlexBox className='no-wrap h-center'>
                                    <ScopeSelection
                                      userText='1 out of 2'
                                      devicesText='2 out of 4'
                                      householdText='4 out of 8'
                                    />
                                </RowFlexBox>
                            </ColumnFlexBox>
                        </RowFlexBox>
                        <div className='demographics'>
                            <div>
                                <span>demographics</span>
                            </div>
                            <RowFlexBox wrap={false}>
                                <DemographicsBox className='gender' title='gender'>
                                    <Gender gender='male' percentage={63} />
                                    <Gender gender='female' percentage={37} />
                                </DemographicsBox>
                                <div className='vertical-separator' />
                                <DemographicsBox className='age' title='age'>
                                    <ColumnFlexBox>
                                        <Chart data={[
                                            {name: '18-24', val: 40},
                                            {name: '25-34', val: 30},
                                            {name: '35-44', val: 15},
                                            {name: '45-54', val: 8},
                                            {name: '55-64', val: 5},
                                            {name: '65+', val: 2}
                                        ]}
                                          fill='#009DDB'
                                          isVertical
                                        />
                                    </ColumnFlexBox>
                                </DemographicsBox>
                                <div className='vertical-separator' />
                                <DemographicsBox className='employment' title='family'>
                                    <ColumnFlexBox>
                                        <Chart data={[
                                            {name: 'single', val: 23},
                                            {name: 'married', val: 77}
                                        ]}
                                          fill='#00ACAB'
                                        />
                                    </ColumnFlexBox>
                                </DemographicsBox>
                            </RowFlexBox>
                        </div>
                        <RowFlexBox className='consumer-goods' width='initial'>
                            <RowFlexBox>
                                <FlexBox>consumer goods</FlexBox>
                            </RowFlexBox>
                            <RowFlexBox>
                                <BrandIndex index={155} name='lowes' />
                                <BrandIndex index={100} name='best-buy' />
                                <BrandIndex index={60} name='sears' />
                                <BrandIndex index={123} name='homedepot' />
                                <BrandIndex index={234} name='staples' />
                            </RowFlexBox>
                        </RowFlexBox>
                    </ScrollableBody>
                </Tab>
                <Tab eventKey={2} title='Selected segments' />
            </Tabs>
        </div>
    )
}

export default Popup



// WEBPACK FOOTER //
// ../src/commons/components/SegmentsPopupContent/index.js